// extracted by mini-css-extract-plugin
export var header = "_sp-1";
export var maskBottom = "_sp-6";
export var maskMiddle = "_sp-7";
export var maskTop = "_sp-5";
export var root = "_sp-0";
export var scrollDownButton = "_sp-3";
export var scrollDownButtonHidden = "_sp-4";
export var viewport = "_sp-2";